<template>
  <div>
    <back-route-hdr :back-mode="'static'"></back-route-hdr>

    <div class="mar-top">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div v-if="refreshTime && !checkinRecodes.length">
          <empty-notice :image="'search'" :desc="'暂无签到信息'"></empty-notice>
        </div>

        <div v-else class="custom-steps">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="(record, idx) in checkinRecodes" :key="idx">
              <template #title>
                <span class="custom-title">{{record.name}}
                  （{{record.employeeNumber || (record.isExternal && "外部") || "-"}}）</span>
                <span class="pull-right text-sm">{{record.checkinDate}}</span>
              </template>
              <template #label>
                <div v-if="record.deptNames && record.deptNames.length">
                  <span>{{record.deptNames[0]}}</span>
                </div>
              </template>
            </van-cell>
          </van-list>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
  import {refreshDebounce} from "../../../../tools/utils";
  import {checkRecode} from "../../../../server"
  import {momentFormat} from "../../../../config/common";

  export default {
    data() {
      return {
        mid: "",
        refreshing: false,
        refreshTime: "",
        checkinRecodes: [],
        finished: false,
        loading: false,
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          pages: 1,
        },
      }
    },
    computed: {},
    created() {
      this.mid = this.$route.params.mid;
    },
    methods: {
      onRefresh() {
        // 刷新防抖动
        if (this.refreshTime && refreshDebounce(this.refreshTime)) {
          this.refreshing = false;
          vtToast('刷新成功');
          return
        }
        this.initChkRecordList();
      },
      initChkRecordList() {
        this.pageInfo.pageNum = 1;
        this.refreshTime = "";
        this.checkinRecodes = [];
        this.finished = false;
        this.onLoad()
      },
      onLoad() {
        this.getChkRecordList(this.pageInfo.pageNum++)
      },
      // 查询服务数据
      getChkRecordList(pageNum) {
        const filter = {
          pageNum,
          pageSize: this.pageInfo.pageSize,
          mid: this.mid,
        };
        !this.refreshing && !this.loading && UILoader.load();
        checkRecode.queryList(this, {queryFilter: filter}).then(({searchCheckinRecord: data = {}}) => {
          UILoader.unload();
          // 列表懒加载
          this.loading = false;
          const {records, pageInfo} = data;
          // console.log(records)
          this.checkinRecodes = this.checkinRecodes.concat((records || []).map(ele => {
            return {
              ...ele,
              ...ele.profile,
              checkinDate: moment(ele.checkinDate).format(momentFormat.dateTimeDetail)
            }
          }));
          if (this.refreshing) {
            this.refreshing = false;
            vtToast('刷新成功');
          }
          this.refreshTime = new Date();
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
        }).catch(err => {
          UILoader.unload();
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
          vtToast(err.message)
        })
      },
    }
  }
</script>

<style scoped>
</style>
